let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("hpJ2V")).then(() => parcelRequire('6lz5f'));